
























































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { directusApi } from '@/api';
import { asyncForEach, orderStoreBadge, validateStatusOrders } from '@/utils';
import _ from 'lodash';
import { Spinner } from 'vue-image-spinner2';
import moment from 'moment-timezone';

@Component({
    name: 'order-detail-modal',
    components: {
        Spinner,
    },
    computed: {
        ...mapState('auth', ['currentUser']),
        ...mapState('orders', ['activeOrderLoading', 'activeOrder']),
        ...mapState('locations', ['activeLocation', 'activeLocationLoading']),
        ...mapState('orders', {
            activeOrder: (state: any) => {
                // console.log(state.activeOrder.splitted_order);
                let active_order = state.activeOrder;
                let logistic_type;
                switch (active_order.logistic_type) {
                    case 'fulfillment':
                        logistic_type = 'FULFILLMENT';
                        break;
                    case 'drop_off':
                        logistic_type = 'REGULAR';
                        break;
                    case 'not_specified':
                        logistic_type = 'A-ACORDAR';
                        break;
                    case 'cross_docking':
                        logistic_type = 'M-E-COLECTA';
                        break;
                    case 'xd_drop_off':
                        logistic_type = 'ML-PLACES';
                        break;
                    default:
                        logistic_type = active_order.logistic_type;
                        break;
                }

                let status: any;
                let status_order: any = [];

                try {
                    status = active_order.status.replace(/ /g, '').split(',');
                    if (active_order.order_status == 'paid' || active_order.order_status == 'success') {
                        let clearStatus: any = _.remove(status, function (n) {
                            return n != 'null' && n != 'paid' && n != 'undefined';
                        });
                        clearStatus = clearStatus[clearStatus.length - 1];
                        status_order = validateStatusOrders(clearStatus, active_order.order_status);
                    } else if (active_order.order_status == 'cancelled') {
                        let clearStatus: any = _.remove(status, function (n) {
                            return n != 'null' && n != 'undefined' && n != 'pack_splitted';
                        });
                        clearStatus = clearStatus[clearStatus.length - 1];
                        status_order = validateStatusOrders(clearStatus, active_order.order_status);
                    }
                } catch (error) {
                    console.log('wait for load data');
                }

                if (active_order.intelisis_movement == 'null' || active_order.intelisis_movement == null) {
                    active_order.intelisis_movement = '';
                }

                if (Array.isArray(active_order.order_items) && active_order.order_items.length > 0) {
                    active_order.order_items = active_order.order_items.map(item => ({
                        ...item,
                        showDetail: false
                    }));
                }

                return {
                    ...active_order,
                    logistic_type,
                    tags: status_order,
                    // order_items
                };
            },
        }),
    },
})
export default class OrderDetailModal extends Vue {
    orderStoreBadge = orderStoreBadge;
    private currentUser!: any;
    private activeOrder!: any;
    private activeOrderLoading!: any;

    private searchQuery: string = '';
    public dataPdf: any = '';
    public pdfSrc: string = '';
    public products_order: any = [];
    public fields_product_order: any = ['id', 'qty', 'price'];

    public saleDetail: any = [];
    public fields_sale_detail: any = ['title', 'sale_fee'];

    public totalOrder: any = 0;
    public amountOrder: any = 0;
    public shipmentCostOrder: any = 0;
    public shippingCostBuyer: any = 0;
    public mlpublications = [];

    private activeLocation!: any;
    private activeLocationLoading!: any;
    public stopLocation = 0;
    public linkedProducts: any;

    package_manager_options: any = [
        { value: null, text: 'Encargado', disabled: true },
        { value: 'Jonathan', text: 'Jonathan' },
        { value: 'Alejandro', text: 'Alejandro' },
        { value: 'Rigoberto', text: 'Rigoberto' },
        { value: 'Manuel', text: 'Manuel' },
    ];
shipment_status_options: any = [
  { value: 'handling', text: 'EN PREPARACIÓN' },
//   { value: 'picked_up', text: 'RECOLECTADO' },
  { value: 'IN_TRANSIT', text: 'EN CAMINO' },
  { value: 'DELIVERED', text: 'ENTREGADO' },
];


    // public intelisis_movement: string = '';

    get permalink() {
        // return `https://www.mercadolibre.com.mx/ventas/${this.activeOrder.id}/detalle`; (node-api)
        if (this.activeOrder.intelisis_movement == 'Sin asignar') {
            this.activeOrder.intelisis_movement = '';
        }
        if (this.activeOrder.logistic_type == 'cotizador') {
            this.quotationProducts();
        } else if (this.activeOrder.logistic_type == 'ecommerce') {
            this.ecommerceProducts();
        } else {
            this.checkProducts();
        }
        return `https://www.mercadolibre.com.mx/ventas/${this.activeOrder.id}/detalle`;
    }

    getOrderUrl(id: string) {
        return `https://prodelec.mx/wp-admin/post.php?post=${id}&action=edit&classic-editor`;
    }

    // mounted() {
    // 	// // setTimeout(() => {
    // 	// this.activeOrder.order_items = JSON.parse(this.activeOrder.order_items);
    // 	// // }, 1000);
    // }

    onSaveOrder() {
        if (this.activeOrder.intelisis_movement == 'null' || this.activeOrder.intelisis_movement == '') {
            this.activeOrder.intelisis_movement == 'null';
        }
        this.$store.dispatch('orders/putOne', {
            // id: this.activeOrder.id, (node-api)
            vm: this,
            id: this.activeOrder.id,
            intelisis_movement: this.activeOrder.intelisis_movement,
            comments: this.activeOrder.comments,
            products: this.products_order,
            logistic_type: this.activeOrder.logistic_type,
            credit_note: this.activeOrder.credit_note,
            package_manager: this.activeOrder.package_manager,
            splitted_order: this.activeOrder.splitted_order,
            balance: this.activeOrder.balance,
          //  shipment_status: this.activeOrder.shipment_status, 
        });
    }

    printLabel() {
        // console.log('Printing label: ', this.activeOrder.shipment_id);
        this.$store.dispatch('orders/printLabel', {
            order_id: this.activeOrder.id,
            shipment_id: this.activeOrder.shipment_id,
        });
    }

    exportPDF() {
        console.log(this.dataPdf);
        var fileURL = window.URL.createObjectURL(new Blob([this.dataPdf]));
        var fileLink = document.createElement('a');
        fileLink.href = window.URL.createObjectURL(this.dataPdf);
        fileLink.setAttribute('download', 'label.pdf');
        document.body.appendChild(fileLink);

        fileLink.click();
    }

    sendPackage() {
        this.$store.dispatch('orders/sendPackage');
    }

    copyToClipboard(order_id: any) {
        navigator.clipboard.writeText(order_id);
    }

    syncOrderStatus(main_id: any, order_id: any, store: any) {
        this.$store.dispatch('orders/syncStatus', {
            main_id,
            order_id,
            store,
            vm: this,
        });
    }

    onGetInvoiceLink(order_id: any) {
        let invoice_link = `https://www.prodelec.mx/factura/generar/${order_id}`;
        navigator.clipboard.writeText(invoice_link);
        this.$bvToast.toast('Se ha copiado el link de facturación 😉', {
            title: `Link de facturación copiado`,
            variant: 'success',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
        });
    }

    onEnableInvoiceLink(order_id: any) {
        this.$bvModal
            .msgBoxConfirm('¿Está seguro de que desea hacer este cambio?', {
                title: 'Habilitando enlace',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Si',
                cancelTitle: 'No',
                cancelVariant: 'secondary',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true,
            })
            .then((value) => {
                if (value === true) {
                    let user_name = this.currentUser.first_name + ' ' + this.currentUser.last_name;
                    this.$store.dispatch('orders/setStatus', {
                        vm: this,
                        user_id: this.currentUser.id,
                        user_name: user_name,
                        email: this.currentUser.email,
                        order_id: order_id,
                        current_date: moment().format('YYYY-MM-DD HH:mm:ss'),
                    });
                }
            })
            .catch((err) => {
                console.log('An error occurred');
            });
    }

    onDisableInvoiceLink(order_id: any) {
        this.$bvModal
            .msgBoxConfirm('¿Está seguro de que desea hacer este cambio?', {
                title: 'Deshabilitando enlace',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Si',
                cancelTitle: 'No',
                cancelVariant: 'secondary',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true,
            })
            .then((value) => {
                if (value === true) {
                    let user_name = this.currentUser.first_name + ' ' + this.currentUser.last_name;
                    this.$store.dispatch('orders/disableInvoice', {
                        vm: this,
                        user_id: this.currentUser.id,
                        user_name: user_name,
                        email: this.currentUser.email,
                        order_id: order_id,
                        current_date: moment().format('YYYY-MM-DD HH:mm:ss'),
                    });
                }
            })
            .catch((err) => {
                console.log('An error occurred');
            });
    }

    canSee(roles: any) {
        let roleValidation = false;
        let user1Id = '8c39c042-be3d-4e7c-9f54-a840d655fe14'; //montufar
        let userdId = '69398834-1969-4dd8-bece-deff3c13404b'; //development
        switch (this.currentUser.role.name) {
            case 'Admin':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'Developer':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'MercadoLibre Manager':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                if (this.currentUser.id != user1Id && this.currentUser.id != userdId) {
                    roleValidation = false;
                }
                break;
            default:
                roleValidation = false;
                break;
        }
        return roleValidation;
    }

    async quotationProducts() {
        // this.amountOrder = 5;
        // this.shipmentCostOrder = 1;
        // this.shippingCostBuyer = 10;
        // this.totalOrder = this.totalOrder - this.shipmentCostOrder;
        // this.totalOrder = 1000;
        this.$store.dispatch('orders/toggleOrderFalse');
    }

    async ecommerceProducts() {
        this.$store.dispatch('orders/toggleOrderFalse');

        if (this.activeOrder.shipment_status == 'pickup' && this.activeOrder.logistic_type == 'ecommerce' && this.stopLocation == 0) {
            this.$store.dispatch('locations/getOne', this.activeOrder.shipping_info.shipping_sucursal_id);
            this.stopLocation++;
        }
    }

    async checkProducts() {
        // console.log(this.activeOrder);
        this.mlpublications = [];
        this.products_order = [];
        this.saleDetail = [];
        this.amountOrder = 0;
        this.shipmentCostOrder = 0;
        this.totalOrder = this.activeOrder.balance;
        let quantity_item: any = 0;
        let sale_fee: any = 0;
        let cont = 0;
        this.linkedProducts = [];
        console.log(this.activeOrder);

        // if(this.activeOrder.products_order.length > 0){
        //      await asyncForEach(this.products_order, async (item: any) => {
        //         console.log(item);

        //         });

        // }
        console.log(this.activeOrder);

        if (this.activeOrder.ml_publications) {
            // console.log('#########################');
            this.mlpublications = this.activeOrder.ml_publications;
            console.log(this.mlpublications);

            this.saleDetail = this.activeOrder.sale_detail;
            this.products_order = this.activeOrder.products_order;

            await asyncForEach(this.products_order, async (product: any) => {
                let coincidence_sale_fee = _.find(this.saleDetail, function (o) {
                    // console.log('coincidence');
                    return o.title == product.title;
                });
                sale_fee += +coincidence_sale_fee.sale_fee;
                // console.log(sale_fee);
                // console.log(this.totalOrder);
            });
            this.totalOrder;
            this.totalOrder = this.totalOrder - sale_fee;
            this.$store.dispatch('orders/toggleOrderFalse');
            // console.log(this.activeOrder.ml_publications);
        } else {
            await asyncForEach(this.activeOrder.order_items, async (item: any) => {
                quantity_item = item.quantity;
                sale_fee = item.sale_fee;
                await directusApi('GET', `custom/legacy-mercadolibre/publicationMl/${item.item.id}`)
                    .then(async (publication: any) => {
                        // console.log(publication.data);
                        // console.log(item.item.seller_sku);
                        // console.log(publication.data.attributes.find((att: any) => att.id == 'SELLER_SKU'));
                        let skuInfo = publication.data.attributes.find((att: any) => att.id == 'SELLER_SKU')
                            ? publication.data.attributes.find((att: any) => att.id == 'SELLER_SKU').value_name
                            : item.item.seller_sku;
                        this.mlpublications.push({
                            id: publication.data.id,
                            title: publication.data.title,
                            price: publication.data.original_price ? publication.data.original_price : publication.data.price,
                            sku: skuInfo,
                            image: publication.data.pictures[0].url,
                            sales: quantity_item,
                        });
                    })
                    .catch((err) => console.log(err));
                await directusApi('GET', `custom/legacy-mercadolibre/publications/${item.item.id}`)
                    .then(async (res: any) => {
                        console.log(res.data);
                        if (res.data.linked_products.length > 0) {
                            console.log('tiene productos');
                            let charges: any = (sale_fee * quantity_item).toFixed(2);
                            this.products_order.push({
                                id_publication: res.data.id,
                                title: res.data.title,
                                sales: quantity_item,
                                flag_products_order: true,
                                linked_products: res.data.linked_products,
                            });
                            this.saleDetail.push({
                                id: cont,
                                title: res.data.title,
                                sale_fee: charges,
                            });
                            this.totalOrder = this.totalOrder - charges;
                            cont++;
                        } else {
                            if (res.data.variations[0] && res.data.variations[0].linked_products.length > 0) {
                                console.log('tiene productos en las variaciones');
                                let variation = _.find(res.data.variations, function (o) {
                                    return o.id == item.item.variation_id;
                                });
                                let charges: any = (sale_fee * quantity_item).toFixed(2);
                                this.products_order.push({
                                    id_publication: res.data.id,
                                    title: res.data.title,
                                    sales: quantity_item,
                                    flag_products_order: true,
                                    linked_products: variation.linked_products,
                                });
                                this.saleDetail.push({
                                    id: cont,
                                    title: res.data.title,
                                    sale_fee: charges,
                                });
                                this.totalOrder = this.totalOrder - charges;
                                cont++;
                            } else {
                                let charges: any = (sale_fee * quantity_item).toFixed(2);
                                this.products_order.push({
                                    id_publication: res.data.id,
                                    title: res.data.title,
                                    flag_products_order: false,
                                });
                                this.saleDetail.push({
                                    id: cont,
                                    title: res.data.title,
                                    sale_fee: charges,
                                });
                                this.totalOrder = this.totalOrder - charges;
                                cont++;
                                console.log('La publicación: ', res.data.id, ' no tiene productos sincronizados');
                            }
                        }
                    })
                    .catch((err) => {
                        console.log('post not found');
                        this.$store.dispatch('orders/toggleOrderFalse');
                    });
            });
            this.$store.dispatch('orders/toggleOrderFalse');
        }
        // if (!this.activeOrder.splitted_order) {
        //     console.log('normal order');

        //     this.$store.dispatch('orders/toggleOrderFalse');
        // }
        // this.activeOrder.balance = +this.activeOrder.balance;
        // this.activeOrder.splitted_order = JSON.parse(this.activeOrder.splitted_order);
        // if (this.activeOrder.splitted_order) {
        //     console.log('splitted order');
        //     this.saleDetail = [];
        //     this.totalOrder = this.activeOrder.balance;
        //     if (this.activeOrder.splitted_order.length) {
        //         if (this.activeOrder.splitted_order.length > 1) {
        //             console.log(this.activeOrder.splitted_order);
        //             await asyncForEach(this.activeOrder.splitted_order, async (order_id: any) => {
        //                 console.log(order_id);
        //                 // await directusApi('GET', `items/mercadolibre_orders/${order_id}`).then(async (order_complete: any) => {
        //                 await directusApi('GET', `items/prodelec_orders/${order_id}`).then(async (order_complete: any) => {
        //                     // console.log(order_complete.data.data.id);
        //                     this.activeOrder.balance += +order_complete.data.data.balance;
        //                     await asyncForEach(order_complete.data.data.order_items, async (item: any) => {
        //                         quantity_item = item.quantity;
        //                         await directusApi('GET', `custom/legacy-mercadolibre/publications/${item.item.id}`)
        //                             .then(async (res: any) => {
        //                                 if (res.data.linked_products.length > 0) {
        //                                     console.log('tiene productos');
        //                                     let charges: any = (sale_fee * quantity_item).toFixed(2);
        //                                     this.products_order.push({
        //                                         id_publication: res.data.id,
        //                                         title: res.data.title,
        //                                         sales: quantity_item,
        //                                         flag_products_order: true,
        //                                         linked_products: res.data.linked_products,
        //                                     });
        //                                     this.saleDetail.push({
        //                                         id: cont,
        //                                         title: res.data.title,
        //                                         sale_fee: charges,
        //                                     });
        //                                     this.totalOrder = this.totalOrder - charges;
        //                                     cont++;
        //                                 } else {
        //                                     if (res.data.variations[0] && res.data.variations[0].linked_products.length > 0) {
        //                                         console.log('tiene productos en las variaciones');
        //                                         let charges: any = (sale_fee * quantity_item).toFixed(2);
        //                                         this.products_order.push({
        //                                             id_publication: res.data.id,
        //                                             title: res.data.title,
        //                                             sales: quantity_item,
        //                                             flag_products_order: true,
        //                                             linked_products: res.data.variations[0].linked_products,
        //                                         });
        //                                         this.saleDetail.push({
        //                                             id: cont,
        //                                             title: res.data.title,
        //                                             sale_fee: charges,
        //                                         });
        //                                         this.totalOrder = this.totalOrder - charges;
        //                                         cont++;
        //                                     } else {
        //                                         let charges: any = (sale_fee * quantity_item).toFixed(2);
        //                                         this.products_order.push({
        //                                             id_publication: res.data.id,
        //                                             title: res.data.title,
        //                                             flag_products_order: false,
        //                                         });
        //                                         this.saleDetail.push({
        //                                             id: cont,
        //                                             title: res.data.title,
        //                                             sale_fee: charges,
        //                                         });
        //                                         this.totalOrder = this.totalOrder - charges;
        //                                         cont++;
        //                                         console.log('La publicación: ', res.data.id, ' no tiene productos sincronizados');
        //                                     }
        //                                 }
        //                                 this.$store.dispatch('orders/toggleOrderFalse');
        //                             })
        //                             .catch((err) => {
        //                                 console.log('post not found');
        //                                 this.$store.dispatch('orders/toggleOrderFalse');
        //                             });
        //                     });
        //                 });
        //             });
        //         } else {
        //             this.$store.dispatch('orders/toggleOrderFalse');
        //         }
        //     } else {
        //         this.$store.dispatch('orders/toggleOrderFalse');
        //     }
        // }

        // console.log(this.saleDetail);
        // console.log(this.shipmentCostOrder);
        // console.log(this.products_order);
        this.activeOrder.total_amount > 0 ? (this.amountOrder = parseFloat(this.activeOrder.total_amount).toFixed(2)) : this.amountOrder;
        this.activeOrder.shipping_cost > 0
            ? (this.shipmentCostOrder = parseFloat(this.activeOrder.shipping_cost).toFixed(2))
            : this.shipmentCostOrder;
        this.activeOrder.shipping_cost_buyer > 0
            ? (this.shippingCostBuyer = parseFloat(this.activeOrder.shipping_cost_buyer).toFixed(2))
            : this.shippingCostBuyer;
        // console.log(this.totalOrder);
        this.totalOrder = this.totalOrder - this.shipmentCostOrder;
        this.totalOrder = parseFloat(this.totalOrder).toFixed(2);
    }
}
